var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1015_31635)","key":0},React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.7023 6.31856L4.57317 0.761644C3.04478 -0.168116 1.14286 1.0082 1.14286 2.87995V13.9932C1.14286 15.8674 3.04478 17.0413 4.57317 16.1115L13.7023 10.5574C15.2421 9.62033 15.2421 7.25564 13.7023 6.31856Z","fill":"#FCFCFC"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1015_31635"},React.createElement("rect",{"width":"16","height":"16","fill":"white","transform":"translate(0 0.436646)"})))]);
}

Play.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = Play;

Play.default = Play;
